<template>
    <div class="panel-body">
        <div class="row">
            <div class="col-md-12">
                <filter-control @params="getFiles" ref="FilterControl" :model="model" :query="query">
                </filter-control>
            </div>
        </div>
        <button @click="displayTable = !displayTable" class="float-right btn btn-sm btn-outline-secondary">
            <i class="nav-icon fa" :class="{'fa-table': displayTable, 'fa-list': !displayTable}"></i>
        </button>
        <div class="row">
            <div class="col-md-12">
                <div class="container-fluid">
                    <p><i class="fa fa-times-circle-o"></i> Arquivos expirados</p>
                </div>
            </div>
        </div>
        <div class="col-md-12" v-if="!displayTable">
            <template v-for="(item, i) in files">
                <file-section @clickOpen="openFileMenu" @showSignatures="showSignatures"
                    @contextmenu.native.prevent="openFileMenu($event, item)" :file="item" :key="i">
                </file-section>
            </template>
        </div>
        <div class="col-md-12" v-else>
            <file-table @clickOpen="openFileMenu" :files="files"></file-table>
        </div>
        <infinite-loading :identifier="loadingId" :distance="5" :forceUseInfiniteWrapper="true" spinner="waveDots"
            @infinite="infiniteHandler">
            <div slot="spinner">Carregando...</div>
            <div slot="no-more">Sem mais arquivos</div>
            <div class="text-center" slot="no-results">Sem mais arquivos</div>
        </infinite-loading>
        <vue-context ref="menuFile" :close-on-click="true" v-slot="{data}">
            <li><a href="#" @click.prevent="showFile(data.id)"><i class="fa fa-eye"></i> Detalhes</a></li>
            <li>
                <a href="#" @click.prevent="copyLink(data)"><i class="fa fa-chain"></i> Copiar link público</a>
            </li>
            <li><a href="#" @click.prevent="downloadFile(data)"><i class="fa fa-cloud-download"></i> Baixar </a>
            </li>
            <li><a href="#" @click.prevent="downloadFileWithLog(data)"><i class="fa fa-download"></i> Baixar com Log
                </a></li>
            <li><a href="#" @click.prevent="deleteFile(data)"><i class="fa fa-trash"></i>
                    Remover</a></li>
        </vue-context>
        <m-file ref="ModalFile" @refreshFiles="fetchFiles"></m-file>
        <m-show-signatures ref="ModalShowSignatures"></m-show-signatures>
    </div>
</template>

<script>
    import FileSection from '../dashboard/components/file-section';
    import FilterControl from '../../components/advanced-filter/FilterControl';
    import mFile from '../../components/file-manipulation/m-file-details';
    import fileOperations from '../dashboard/functions/fileOperations';
    import MShowSignatures from '../../components/file-manipulation/m-show-signatures.vue';
    import FileTable from '../dashboard/components/file-table.vue';
    export default {
        components: {
            FileTable,
            FileSection,
            FilterControl,
            mFile,
            MShowSignatures
        },
        data() {
            return {
                displayTable: false,
                loadingId: null,
                selectedFile: {},
                storeAction: 'SET_EXPIRADOS',
                infiniteAction: 'ADD_EXPIRADOS',
                url: '/api/expirados',
                query: {
                    order_column: 'created_at',
                    order_direction: 'desc',
                    filter_match: 'and',
                    limit: 5,
                    page: 1
                },
                model: 'expirados',
            };
        },
        beforeMount() {
            this.createUUID = this.createUUID.bind(this);
            this.showFile = fileOperations.showFile.bind(this);
            this.downloadFile = fileOperations.downloadFile.bind(this);
            this.deleteFile = fileOperations.deleteFile.bind(this);
            this.downloadFileWithLog = fileOperations.downloadFileWithLog.bind(this);
            this.fetchFiles = fileOperations.fetchFiles.bind(this);
            this.getFiles = fileOperations.getFiles.bind(this);
            this.copyLink = fileOperations.copyLink.bind(this);
            this.infiniteHandler = fileOperations.infiniteHandler.bind(this);
            this.openFileMenu = fileOperations.openFileMenu.bind(this);
            this.showSignatures = fileOperations.showSignatures.bind(this);
            this.loadingId = this.createUUID();
        },
        computed: {
            files() {
                return this.$store.state.expirados.data
            }
        },
        watch: {
            $route(data) {
                if (data.name == '451') {
                    this.$destroy();
                }
            }
        },
    };
</script>